<template>
  <div class="l-learn-voice-test l-learn-content-w-container" v-if="element">
    <div class="l-learn-voice-mask" @click="onHandPlay" v-if="audio.isShowPlay"></div>
    <!-- 题干图片 -->
    <div class="l-learn-question-stem-all">
      <div class="l-learn-question-stem">
        <LImage :url="currentTestItem.realQuestionImageUrl" :isScroll="false" />
        <LNumber :current="element.currentCount" :total="element.totalCount" class="l-learn-number" />
      </div>
    </div>
    <!-- 答题-录音 -->
    <div class="lSoundRecording-btn">
      <lRecorder ref="recorder" :disabled="recordStatus == 0" :options="recorderOptions" :allow-manual="true"
        @result="onresult" @init="onRecordInit" />
    </div>
  </div>
</template>

<script>
import version from '@/utils/version'
import laudio from '@/utils/laudio'
import { lLoading } from '@/components/l-loading'
import LImage from '../../components/l-image'
import LNumber from '../../components/l-number'
import lRecorder from '../../components/l-recorder'
import UPModel from '@/models/imgup'
import localKeyLock from '@/utils/localKeyLock'
import { createNamespacedHelpers } from 'vuex'
import { sleep } from '../../../../utils/util'
import { recordStudyPlayData } from '@/utils/record'

const userMapGetters = createNamespacedHelpers('user').mapGetters
const { mapActions, mapGetters } = createNamespacedHelpers('course')
const up = new UPModel()
const AUDIO_READ = 'AUDIO_READ'
const AUDIO_READ_LAST_KEY = `${AUDIO_READ}_LAST_KEY`

export default {
  name: 'l-learn-voice-test',
  components: { LImage, LNumber, lRecorder },
  data() {
    return {
      LOCAL_STAGE_KEY: 'AUDIO_READ',
      LOCAL_RECORD_TIME_KEY: '', // 录音次数本地KEY
      laudio: null,
      recordStatus: 0, // 0,1,2 录音状态
      isPlayClick: false, // 是否点击
      stage: '', // 当前答题阶段
      audioData: '', // 录音数据
      refText: '', // 答案
      keywords: '', // 中心词
      currentTestItem: {},
      STAGE_TYPES: {
        isStart: 'START', //默认状态
        isAudioExplain: 'AUDIO_EXPLAIN',
      },
      audio: {
        autoplay: true, // 自动播放
        isShowPlay: false, // 播放按钮
        isPlay: false, // 是否播放中
      },

      recorderOptions: {}, // 录音配置参数
      playTimer: null,
      playTime: 0, // 进入页面开始播放的播放时长
    }
  },
  computed: {
    ...mapGetters(['element', 'highWord']),
    ...userMapGetters(['user']),
  },
  watch: {
    async 'element.ELEMENT_TYPE'(to) {
      if (to) {
        if (this.element.currentCount > this.element.totalCount) {
          this._next('该元素记录已存在')
          return
        }
        this.currentTestItem = this.element.datas[this.element.currentCount - 1]
        if (this.currentTestItem) {
          this._initSourceUrl()

          // 录音参数
          this.recorderOptions.elementType = this.element.type
          this.recorderOptions.text = (
            await this._getText(this.currentTestItem.attrs.answerTxt)
          ).data[0]
          this.recorderOptions.keywords = (
            await this._getText(this.currentTestItem.attrs.keywordTxt)
          ).data[0]

          this.recorderOptions.duration = this.element.attrs.answerRecordTime
          this.recorderOptions.audioFileName = `${this.element.RECORD_ID}-${this.currentTestItem.id}`
        }
      }
    },
  },
  methods: {
    ...mapActions(['STUDY_RESULT']),
    // 录音初始化成功
    onRecordInit() {
      // 提示带耳机，并主动触发开始
      this.$refs.recorder.start()
      this._countTime()
    },
    // 录音完成
    onresult(data) {
      this.audioData = data

      if (this.audioData) {
        this.audioData.suggestedScore = this.audioData.suggestedScore
          ? this.audioData.suggestedScore
          : 1
        this._submit()

        recordStudyPlayData({
          id: this.element.id,
          bizType: this.element.type,
          type: 1,
          offset: this.playTime,
        }, this.element.ELEMENT_TYPE)
      }
    },
    // 获取资源全路径
    _initSourceUrl(type) {
      up.resource({
        paths: [
          this.currentTestItem.attrs.questionImageUrl,
          this.currentTestItem.attrs.rightAudioUrl,
          this.currentTestItem.attrs.wrongAudioUrl,
          this.currentTestItem.attrs.questionAudioUrl,
        ],
      })
        .then((res) => {
          this.$set(this.currentTestItem, 'realQuestionImageUrl', res.data[0])
          this.$set(this.currentTestItem, 'realRightAudioUrl', res.data[1])
          this.$set(this.currentTestItem, 'realWrongAudioUrl', res.data[2])
          this.$set(this.currentTestItem, 'realQuestionAudioUrl', res.data[3])
          if (type == 'submit') {
            this.laudio = laudio({
              autoplay: this.audio.autoplay,
              src:
                this.audioData.suggestedScore >= 43
                  ? this.currentTestItem.realRightAudioUrl
                  : this.currentTestItem.realWrongAudioUrl,
            })

            if (this.laudio) {
              this._initEvent('submit')
            }
          }
          if (type != 'submit') {
            this._initStage()
          }
        })
        .catch((err) => {
          this.$lPrompt({
            message: err.msg,
            successTxt: this.$locale.确定,
          })
          if (type != 'submit') {
            this._initStage()
          }
        })
    },
    //根据关键词修改
    _getText(text) {
      return up.getContent({
        paths: [text],
      })
    },
    //根据缓存初始化当前元素的学习进度
    _initStage() {
      // 当前学习元素+当前学生记录+当前题目
      const currentValueKey = `${this.LOCAL_STAGE_KEY}_${this.element.RECORD_ID}_${this.currentTestItem.id}`
      const localKey = AUDIO_READ_LAST_KEY
      this.LOCAL_STAGE_KEY = localKeyLock(localKey, currentValueKey)
      this.LOCAL_RECORD_TIME_KEY = `${this.LOCAL_STAGE_KEY}_TIME`

      try {
        const currentRecord = JSON.parse(
          localStorage.getItem(this.LOCAL_STAGE_KEY)
        )
        // 初始化stage数据，什么都没有，则为题干讲解状态
        this.stage =
          currentRecord && currentRecord.stage
            ? currentRecord.stage
            : this.STAGE_TYPES.isStart
        if (this.stage == this.STAGE_TYPES.isAudioExplain) {
          this.recordStatus = 1
          this._initAudio(false)
        } else {
          this.audio.isShowPlay = true
          this._initAudio()
        }
      } catch (error) {
        // 报错，默认什么都没有，则为初始化状态
        this._localStage({ stage: this.STAGE_TYPES.isStart })
        this.audio.isShowPlay = true
        this._initAudio()
      }
    },
    // 初始化音频
    _initAudio(status) {
      this.laudio = laudio({
        autoplay: status == false ? false : this.audio.autoplay,
        src: this.currentTestItem.realQuestionAudioUrl,
      })
      if (this.laudio) {
        this._initEvent()
      }
    },
    // 监听事件
    _initEvent(type) {
      // 监听播放事件
      this.laudio.addEventListener('play', () => {
        this.audio.isShowPlay = false
        this.audio.isPlay = true
        this.recordStatus = 0
      })

      // 监听暂停事件
      this.laudio.addEventListener('pause', () => {
        this.audio.isPlay = false
      })

      // 播放完成
      this.laudio.addEventListener('ended', () => {
        this._localStage({ stage: this.STAGE_TYPES.isAudioExplain })
        this.recordStatus = 1
        this.audio.isPlay = false
        if (type == 'submit') {
          this._next()
        }
        // ios系统在手动触发题干音的情况下，题干音播放完刷新页面
        if (this.isPlayClick) {
          this.isPlayClick = false
          location.reload()
        }
      })
    },

    // 手动触发播放
    async onHandPlay() {
      if (version.isIOS() && version.isLILYTribeAPP()) {
        lLoading.show()
        await sleep(1)
        lLoading.hide()
      }
      this.laudio.play()
      if (this.stage == this.STAGE_TYPES.isStart && !version.isPC()) {
        this.isPlayClick = true
      }
    },
    // 缓存当前学习进度，防止刷新丢失
    _localStage(params) {
      if (params) {
        this.stage = params.stage
        localStorage.setItem(this.LOCAL_STAGE_KEY, JSON.stringify(params))
      } else {
        localStorage.removeItem(this.LOCAL_STAGE_KEY)
      }
    },
    // 提交答案
    _submit() {
      // 提交答题
      if (this.audioData && this.audioData.suggestedScore) {
        this.STUDY_RESULT({
          elementId: this.element.id,
          postData: {
            eleId: this.element.id,
            ...this.audioData,
          },
        })
          .then(() => {
            this._next()
          })
          .catch((err) => {
            this.$lPrompt({
              message: `提交失败：${err.message || err.msg}`,
              successTxt: this.$locale.确定,
            })
          })
      }
    },
    // 下一节点
    _next(msg) {
      const message =
        msg ||
        `你的复述结果为：${this.element.records[this.element.currentCount - 1].word
        }，继续加油哦！`
      localStorage.removeItem(this.LOCAL_STAGE_KEY)

      this.$lPrompt({
        message,
        successTxt: this.$locale.确定,
        successFn: () => {
          this.$emit('next')
        },
      })
    },
    // 修改子组件的参数
    onSetStatus(status) {
      if (status == 2) {
        this.recordStatus = status
      } else if (status == 1) {
        this.recordStatus = 1
      } else {
        this.recordStatus = 0
      }
    },
    // 播放计时
    _countTime() {
      this.playTimer = setInterval(() => {
        this.playTime += 1
      }, 1000)
    },
  },
  destroyed() {
    if (this.laudio) {
      this.laudio.pause()
    }
    if (this.playTimer) {
      clearInterval(this.playTimer)
    }
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
